import React from 'react'
import { Wrapper } from 'lib/noop-wrapper'
import { allDefaultSort, seoDefaultTab } from 'New/community-topic/utils'

export function makeTopicUrl({
  id,
  tab = seoDefaultTab,
  sort = allDefaultSort,
  page,
}: {
  id: string
  tab?: string
  sort?: string
  page?: number
}) {
  const tabSort =
    sort === allDefaultSort
      ? tab === seoDefaultTab
        ? ''
        : tab
      : `${tab}-${sort}`

  const realPage = page && page > 1 ? page : ''

  const append = tabSort
    ? `${tabSort}${realPage ? `-${realPage}` : ''}`
    : realPage

  return `/topic/${id}${append ? `/${append}` : ''}`
}

interface ITopicLinkParams {
  id?: string
}

function topicLink({ id }: ITopicLinkParams): Wrapper {
  return (content) => {
    return id ? (
      <a href={makeTopicUrl({ id })} target={'_blank'}>
        {content}
      </a>
    ) : (
      content
    )
  }
}

export default topicLink
